// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-opened{overflow-y:hidden!important;transform:none!important}.nowrap{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
